/** @format */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Axios from 'axios';

import { Endpoints as url } from '../../lib/endpoints';
import { getCurrentUserToken } from '../../lib/auth';

import {
  Button,
  Icon,
  Message,
  MessageHeader,
  MessageContent,
  ModalHeader,
  ModalDescription,
  ModalContent,
  ModalActions,
  Modal,
} from 'semantic-ui-react';

const headers = {
  'Content-Type': 'application/json',
  Authorization: getCurrentUserToken(),
};

export const ApplicationFromV2ToV1 = ({ application, onChange = () => {} }) => {
  const [open, setOpen] = useState(false);

  const click = () => {
    // Logic to convert application from v2 to v1
    // eslint-disable-next-line no-console
    setOpen(true);
    // You can add your conversion logic here
  };

  const onSave = () => {
    Axios.put(
      url.ApplicationConvertToV2(application.id),
      {},
      {
        headers,
      },
    )
      .then(response => {
        onChange({});
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Error converting application:', error);
        // Optionally, you can show an error message to the user
      });

    setOpen(false);
  };

  return (
    <>
      <Button
        floated="right"
        style={{ marginTop: '2.4em' }}
        labelPosition="left"
        compact
        icon
        color="red"
        onClick={click}
      >
        <Icon name="exchange" />
        Convert to v2
      </Button>

      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <ModalHeader>Transfer the v1 to v2 application</ModalHeader>
        <ModalContent image>
          <ModalDescription>
            <Message negative icon>
              <Icon name="warning sign" />
              <MessageContent>
                <MessageHeader>Attention!</MessageHeader>
                <p>
                  The application will be transferred to api V2, the operation
                  is not reversible
                </p>
              </MessageContent>
            </Message>
            <p>If you want to continue, please click on the Save button.</p>
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="red" onClick={() => setOpen(false)}>
            Close
          </Button>
          <Button onClick={onSave}>Save</Button>
        </ModalActions>
      </Modal>
    </>
  );
};

ApplicationFromV2ToV1.propTypes = {
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
    apiVersion: PropTypes.string,
    UserId: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func,
};
